/** @jsx jsx */
import { Helmet } from 'react-helmet'
import Breadcrumbs from '../../componentsV2/breadcrumbs'
import useBreadcrumbs from '../../componentsV2/hooks/useBreadcrumbs'
import { FeaturedCollectionInterface } from '../collections-header/types'
import { PageProps } from 'gatsby'
import { ReactNode } from 'react'
import { jsx, Container, SxStyleProp, Divider } from 'theme-ui'
import { HeaderVariantType, HeroHeader, Maybe } from '~/@types/models'
import CollectionsHeader from '~/components/collections-header'
import Layout from '~/components/layout/index'
import useShopifyBreadcrumbs from '~/componentsV2/hooks/useShopifyBreadcrumbs'
import useMediaQuery from '~/hooks/use-media-query'

interface Props extends PageProps {
  title: string
  seoTitle?: string
  heading?: string
  handle: string
  description?: string
  image?: Maybe<string>
  contentAfter?: ReactNode
  headerVariant?: HeaderVariantType
  heroHeader?: Maybe<HeroHeader>
  containerSx?: SxStyleProp
  showFeaturedCollections?: boolean
  featuredCollectionsList?: FeaturedCollectionInterface[]
  ankleContent?: string
  noIndex?: boolean
}

const CollectionLayout = ({
  title,
  seoTitle,
  heading,
  handle,
  description,
  image,
  children,
  contentAfter,
  headerVariant,
  heroHeader = null,
  containerSx,
  showFeaturedCollections,
  featuredCollectionsList,
  ankleContent,
  noIndex,
  ...rest
}: Props) => {
  const isMobile = useMediaQuery({
    query: breakpoints => `(max-width: ${breakpoints[2]})`,
  })

  const { breadcrumbs } = useShopifyBreadcrumbs()

  return (
    <Layout
      title={title}
      seoTitle={seoTitle || title}
      description={description}
      ankleContent={ankleContent}
      image={image as string}
      headerVariant={headerVariant ? 'light' : 'default'}
      isCollection
      {...rest}
    >
      <Helmet>
        <meta name="robots" content={noIndex ? 'noindex' : 'index'} />
      </Helmet>
      <CollectionsHeader
        title={heading || title}
        description={description}
        heroHeader={heroHeader}
        containerSx={containerSx}
        showFeaturedCollections={showFeaturedCollections}
        handle={handle}
        featuredCollectionsList={featuredCollectionsList}
      />
      <Container my={['md']}>
        {!isMobile && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <Divider />
        {children}
      </Container>
      {contentAfter}
    </Layout>
  ) as JSX.Element
}

export default CollectionLayout
